export const GET_SUBSCRIPTION_PLANS_REQUEST = "GET_SUBSCRIPTION_PLANS_REQUEST";
export const GET_COMPANY_SUBSCRIPTION_REQUEST = "GET_COMPANY_SUBSCRIPTION_REQUEST";
export const CREATE_RAZORPAY_ORDER_REQUEST = "CREATE_RAZORPAY_ORDER_REQUEST";
